
export const dissabilityList = [
    "Blindness",
    "Low-vision",
    "Leprosy Cured persons",
    "Hearing impairment (Deaf)",
    "Locomotor Disability",
    "Dwarfism",
    "Intellectual Disability",
    "Mental Illness",
    "Autism Spectrum Disorder",
    "Cerebral Palsy",
    "Muscular Dystrophy",
    "Chronic Neurological Conditions",
    "Specific Learning Disabilities",
    "Multiple Sclerosis",
    "Speech and Language Disability",
    "Thalassemia",
    "Hemophilia",
    "Sickle cell disease",
    "Multiple Disabilities including deaf-blindness",
    "Acid Attack Survivor",
    "Parkinson’s disease"
  ]

  export const typesOfParticipations = [
    "Delegate"
]

export const typeOfRegistrations = [
  "Delegate",
  "Student",
  "Person with Disability"
]

export const typeOfRegistrationsOrganization = [
  "Delegate",
  "Student",
  "Person with Disability",
  "Person with Disability (With Accompanying Person)"
]

export const registrationCategories = [
  "Full Conference",
  "One day Conference"
]

export const daysAvailable = [
  "Oct 2",
  "Oct 3",
  "Oct 4"
]

export const genders = [
  "Male",
  "Female",
  "Others",
  "Prefer not to say"
]

export const exhibitTypes = [
  "Startup", 
  "Commercial Distributor",
  "Organization"
]



